import { useMemo } from 'react'
import type { IParamsTestTrigger } from 'entities/Trigger/api/type'
import { TriggerApi } from 'entities/Trigger/api/trigger'
import { TestSMS } from 'widgets/TestSMS'
import { useDetailsTriggerModalContext } from 'widgets/TriggerActions/ui/TriggerDetailsModal/context/detailsTriggerModalContext'

export const DetailsTriggerFooter = () => {
  const trigger = useDetailsTriggerModalContext()

  const onTestSMSTrigger = (params: IParamsTestTrigger) => TriggerApi.createTest(params)

  const testSMSParams = useMemo(() => {
    const params: IParamsTestTrigger = {
      media_url: trigger.media_url,
      message: trigger.message,
      tags: trigger.tags.map((tag) => tag.id),
    }

    if (trigger.type === 'rcs') {
      params.team_id = trigger.inboxId
    } else {
      params.number_id = trigger.testNumberId || 0
    }

    return params
  }, [trigger])

  if (trigger.type === 'ringless') return null

  return (
    <TestSMS
      params={testSMSParams}
      disabled={trigger.isInvalid}
      request={onTestSMSTrigger}
      isTopError
    />
  )
}
